import React, { useState, useEffect } from "react";
import { Background, Close, Container, Field, Form, Header } from "./style";
import Input from "../../Input";
import Icone from "../../../utils/Icone";
import Button from "../../Button";
import api from "../../../Services/api";
import { Alert } from "../../../utils/Alert";

const EsqueciSenhaModal = ({ Show, setShow, perfil }) => {
  const [rm, setRm] = useState("");
  const [email, setEmail] = useState("");
  const [nascimento, setNascimento] = useState("");
  const [tempoRestante, setTempoRestante] = useState(0);
  const [podePressionar, setPodePressionar] = useState(false);

  const data =
    perfil == "aluno"
      ? {
          rm: rm,
          email: email,
          dt_nascimento: nascimento,
        }
      : {
          email: email,
        };

  useEffect(() => {
    if (tempoRestante > 0) {
      setPodePressionar(false);
      const temporizador = setTimeout(() => {
        setTempoRestante((prev) => prev - 1);
      }, 1000);
      return () => clearTimeout(temporizador);
    } else {
      setPodePressionar(true);
    }
  }, [tempoRestante]);

  async function HandleSubmit() {
    const hoje = new Date().toLocaleString("pt-br");
    const ano = hoje.split(",")[0].split("/")[2];
    if (perfil == "aluno" && !data.rm) {
      return Alert({ tipo: "Alert3", mensagem: "Insira seu RM" });
    } else if (perfil == "aluno" && !data.dt_nascimento) {
      return Alert({ tipo: "Alert3", mensagem: "Insira sua DATA DE NASCIMENTO" });
    } else if (
      perfil == "aluno" &&
      data.dt_nascimento &&
      (data.dt_nascimento.split("-")[0] > ano - 14 || data.dt_nascimento.split("-")[0] < ano - 80)
    ) {
      return Alert({ tipo: "Alert3", mensagem: "Insira uma DATA DE NASCIMENTO válida!" });
    } else if (!data.email) {
      return Alert({ tipo: "Alert3", mensagem: "Insira seu E-MAIL" });
    } else {
      try {
        setPodePressionar(false);
        setTempoRestante(30);
        const res = await api.put(`/${perfil}/recuperar-senha`, { data });
        Alert({ tipo: "Sucesso", mensagem: res.data.mensagem?.split(".")[0] });
      } catch (error) {
        console.log(error);
        Alert({
          tipo: "Erro",
          mensagem: `${
            error.response.data.erro == undefined ? "Erro interno de server" : error.response.data.erro.split(".")[0]
          }`,
        });
      }
    }
  }

  if (Show == true) {
    return (
      <Background Show={Show}>
        <Container>
          <Header>
            <Close
              onClick={() => {
                setShow(false);
                setRm("");
                setEmail("");
                setNascimento("");
              }}
            >
              <Icone name={"X"} color={" var(--azul)"} size={32} />
            </Close>
            {/* {perfil == "aluno" ? "Aluno" : "Servidor"}
            <br /> */}
            Recuperar senha
          </Header>
          <Form>
            <Field>
              {perfil == "aluno" && (
                <Input
                  placeholdercolor="var(--azul)"
                  placeholder="RM"
                  width="250px"
                  value={rm}
                  event={(e) => {
                    setRm(e.target.value);
                  }}
                  color="var(--azul)"
                />
              )}
              <Input
                placeholdercolor="var(--azul)"
                placeholder="Email cadastrado"
                color="var(--azul)"
                value={email}
                event={(e) => {
                  setEmail(e.target.value);
                }}
              />
              {perfil == "aluno" && (
                <Input
                  type="date"
                  placeholdercolor="var(--azul)"
                  placeholder="Data de Nascimento"
                  color="var(--azul)"
                  value={nascimento}
                  event={(e) => {
                    setNascimento(e.target.value);
                  }}
                />
              )}
            </Field>
            {!podePressionar ? (
              <>
                <p>Você poderá pressionar novamente em {tempoRestante} segundos.</p>
                <Button
                  width="150px"
                  height="52px"
                  placeholder="Enviar"
                  disabled
                  event={(e) => {
                    e.preventDefault();
                    HandleSubmit();
                  }}
                />
              </>
            ) : (
              <Button
                width="150px"
                height="52px"
                placeholder="Enviar"
                event={(e) => {
                  e.preventDefault();
                  HandleSubmit();
                }}
              />
            )}
          </Form>
        </Container>
      </Background>
    );
  } else {
    return null;
  }
};

export default EsqueciSenhaModal;
